import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import JsonExcel from 'vue-json-excel'
import VueSweetalert2 from 'vue-sweetalert2'
import './main.scss'
import 'sweetalert2/dist/sweetalert2.min.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueScrollTo from 'vue-scrollto'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)
Vue.use(VueScrollTo)
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);
Vue.use(require('vue-moment'));
Vue.component('downloadExcel', JsonExcel)
Vue.use(VueGoogleMaps, {
  load: {
    //set google map api key
    key: 'AIzaSyB60wYZ_FjVNgdcdj6nF_uVdBWIgm8z-Ms',
    libraries: 'places',
    region: 'TH',
    language: 'th'
  },
  installComponents: true

})


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
